import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderSlot as _renderSlot, withKeys as _withKeys, normalizeStyle as _normalizeStyle, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["id", "aria-hidden"]
const _hoisted_2 = { class: "modal-content rounded-4 p-4" }
const _hoisted_3 = { class: "float-start icon" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "modal-title" }
const _hoisted_6 = ["aria-label"]
const _hoisted_7 = { class: "modal-body py-0" }
const _hoisted_8 = {
  class: "modal-backdrop fade show",
  id: "backdrop",
  style: {"display":"block"}
}

import { getUniqueNumber } from "@/guiide/ts/utilities";
    import { ref, computed, nextTick } from "vue";

    
export default /*@__PURE__*/_defineComponent({
  __name: 'Modal',
  props: {
        idKey: { type: String, required: true },
        title: { type: String, required: true },
        icon: { type: String, required: false, default: "" },
        isWide: { type: Boolean, required: false, default: false },
        showClose: { type: Boolean, default: true },
        returnFocusTo: { type: HTMLElement, required: false },
        checkForCustomIcon: { type: Boolean, default: false, required: false },
        customIconOverride: { type: String, default: "", required: false },
        closeButtonAriaLabel: { type: String, default: "Close", required: false },
        customStyles: { type: String, default: "", required: false },
        hideHeader: { type: Boolean, required: false, default: false }
    },
  emits: ['closed'],
  setup(__props, { expose: __expose, emit: __emit }) {

    const props = __props;

    __expose({ showModal, closeModal });

    const emit = __emit;

    const theModal = ref(null);
    const closeButton = ref(null);
    const displayModal = ref(false);
    const isAriaHidden = ref(true);

    const getSizeClass = computed<string>(() => {
        return props.isWide ? "modal-lg" : "";
    });

    const showCustomIconOverride = computed<Boolean>(() => props.customIconOverride.length > 0);

    const headerClass = computed<String>(() => props.hideHeader ? "visually-hidden" : "");

    function showIcon() {
        return props.icon.length > 0;
    }

    async function showModal(initializer: () => void) {
        isAriaHidden.value = false;
        await nextTick();

        // Keep focus within modal while showing
        document.getElementById("app")?.setAttribute("inert", "");

        lockScroll();

        displayModal.value = true;

        if (initializer) {
            nextTick(initializer);
        } else {
            requestAnimationFrame(() => {
                closeButton.value?.focus();
            });
        }
    }

    function closeModal() {
        isAriaHidden.value = true;

        if (props.returnFocusTo) {
            requestAnimationFrame(() => {
                props.returnFocusTo?.focus();
            });
        }

        // Remove modal focus
        document.getElementById("app")?.removeAttribute("inert");

        unlockScroll();

        displayModal.value = false;

        emit('closed');
    }

    function getModalId(): string {
        const uniqueIdGuarantee = getUniqueNumber();
        return `${props.idKey}${uniqueIdGuarantee}Modal`;
    }

    function lockScroll() {
        document.body.dataset.scrollY = window.scrollY;

        document.body.style.overflowX = "hidden";
        document.body.style.overflowY = "hidden";

        document.body.style.position = "relative";
    }

    function unlockScroll() {
        const y = parseInt(document.body.dataset.scrollY, 10);

        document.body.style.overflowX = "";
        document.body.style.overflowY = "";
        document.body.style.position = "";

        requestAnimationFrame(() => {
            window.scrollTo(0, y);
        });
    }


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _withDirectives(_createElementVNode("div", {
      ref_key: "theModal",
      ref: theModal,
      class: "modal fade show",
      id: getModalId(),
      tabindex: "-1",
      "aria-hidden": isAriaHidden.value,
      onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (closeModal()), ["esc"])),
      style: _normalizeStyle(['display: block;', __props.customStyles])
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["modal-dialog modal-dialog-centered modal-dialog-scrollable", getSizeClass.value])
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: _normalizeClass(["modal-header bg-white pb-0", headerClass.value])
          }, [
            _withDirectives(_createElementVNode("span", _hoisted_3, [
              (showCustomIconOverride.value)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: __props.customIconOverride,
                    style: {"width":"1.4rem"}
                  }, null, 8, _hoisted_4))
                : (_openBlock(), _createElementBlock("i", {
                    key: 1,
                    class: _normalizeClass(["bi", __props.icon])
                  }, null, 2))
            ], 512), [
              [_vShow, showIcon()]
            ]),
            _createElementVNode("h3", _hoisted_5, _toDisplayString(__props.title), 1),
            (__props.showClose)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  ref_key: "closeButton",
                  ref: closeButton,
                  type: "button",
                  class: "btn-close d-flex justify-content-center align-items-center",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (closeModal())),
                  "aria-label": __props.closeButtonAriaLabel
                }, _cache[2] || (_cache[2] = [
                  _createElementVNode("i", { class: "bi bi-x-lg btn-close-x" }, null, -1)
                ]), 8, _hoisted_6))
              : _createCommentVNode("", true)
          ], 2),
          _createElementVNode("div", _hoisted_7, [
            _renderSlot(_ctx.$slots, "default")
          ])
        ])
      ], 2)
    ], 44, _hoisted_1), [
      [_vShow, displayModal.value]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_8, null, 512), [
      [_vShow, displayModal.value]
    ])
  ]))
}
}

})